// Copyright (c) 2016 Deere & Company

import BatteryClaim from '@deere/cps-it.warranty-model-factory/lib/claim-battery';

export const getUpdatedBatteryClaim = (currentClaim, selectedAction) =>
    BatteryClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/battery/services/update-battery-claim.js